import { call, all, put, takeEvery } from 'redux-saga/effects';
import {
  getAssessmentCyclesFailureAction,
  getAssessmentCyclesSuccessAction,
  setAssessmentCyclesSuccessAction,
  setAssessmentCyclesFailureAction,
  getAssessmentCycleSuccessAction,
  getAssessmentCycleFailureAction,
  getAssessmentCyclesListSuccessAction,
  getAssessmentCyclesListFailureAction
} from '../../features/assessmentCycles/assessmentCyclesSlice';
import URLs from '../../../constants/urls';
import { GET_ASSESSMENT_CYCLE, GET_ASSESSMENT_CYCLES, SET_ASSESSMENT_CYCLES } from '../../actions/AssessmentCycles/actionTypes';
import { apiPython as api } from '../../../service/api';

export function* getAssessmentCyclesSaga(action) {
  //console.log("Saga Triggered with Action: ", action);
  try {
    const response = yield api.get(URLs.GET_ASSESSMENT_CYCLES);
    //console.log("API Response in Saga:", response);

    const cycles = response.data.data;
    console.log("API Response in getAssessmentCyclesSaga: ",cycles);

    yield put(getAssessmentCyclesSuccessAction({
      assessmentCycleList: cycles.assessmentCycleList,
      assessmentCycleTypeList: cycles.assessmentCycleTypeList,
      innovationTypeQuestions: cycles.innovationTypeQuestions,
      contributionTypeQuestions: cycles.contributionTypeQuestions,
      skillArea: cycles.skillArea,
      assessmentList: cycles.assessmentList
    }));
    
  } catch (error) {
    const serializedError = {
      message: error.message,
      code: error.code,
      status: error.response?.status,
      data: error.response?.data,
    };
    console.error("Error in getAssessmentCycleSaga: ",serializedError);
    yield put(getAssessmentCyclesFailureAction(serializedError));
  }
}

export function* getAssessmentCyclesListSaga() {
  try {
    const response = yield api.get(URLs.GET_ASSESSMENT_CYCLES_LIST);
    yield put(getAssessmentCyclesListSuccessAction(response.data.data));
  } catch (error) {
    yield put(getAssessmentCyclesListFailureAction(error));
  }
}
export function* getAssessmentCycleSaga({ payload: id }) {
  try {
    const response = yield api.get(`${URLs.GET_ASSESSMENT_CYCLE}?id=${id}`);
    yield put(getAssessmentCycleSuccessAction(response.data.data));
  } catch (error) {
    const serializedError = {
      message: error.message,
      code: error.code,
      status: error.response?.status,
      data: error.response?.data,
    };
    yield put(getAssessmentCycleFailureAction(serializedError));
  }
}


export function* setAssessmentCyclesSaga({ payload: body }) {
  try {
    const parsed = typeof body === 'string' ? JSON.parse(body) : body;
    const response = yield api.post(URLs.SET_ASSESSMENT_CYCLES, parsed);
    console.log('Payload being sent:', body);
    yield put(setAssessmentCyclesSuccessAction(response.data));
  } catch (error) {
    const serializedError = {
      message: error.message,
      code: error.code,
      status: error.response?.status,
      data: error.response?.data,
    };
    yield put(setAssessmentCyclesFailureAction(serializedError));
    console.error('API Error:', serializedError);
  }
}


export function* watchAssessmentCycle() {
  yield takeEvery(GET_ASSESSMENT_CYCLES, getAssessmentCyclesSaga);
  yield takeEvery(GET_ASSESSMENT_CYCLE, getAssessmentCycleSaga);
  yield takeEvery(SET_ASSESSMENT_CYCLES, setAssessmentCyclesSaga);
}

export default function* assessmentCycleSaga() {
  yield all([watchAssessmentCycle()]);
}
